import type * as SchemaTypes from '../../../../apolloClient.types';

import type { BmpAssessmentResultFragment, BmpAssessmentResultDataFragment } from '../Create/CreatePerformanceBmpResult.api';
import { gql } from '@apollo/client';
import { BmpAssessmentResultDataFragmentDoc, BmpAssessmentResultFragmentDoc } from '../Create/CreatePerformanceBmpResult.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePerformanceBmpResultsMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateBmpResultInput;
}>;


export type UpdatePerformanceBmpResultsMutation = (
  { __typename: 'Mutation' }
  & { updateBmpResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateBmpResultSuccessfulResponse' }
    & { result: (
      { __typename: 'PerformanceResult' }
      & BmpAssessmentResultFragment
    ) }
  ) }
);


export const UpdatePerformanceBmpResultsDocument = /*#__PURE__*/ gql`
    mutation UpdatePerformanceBmpResults($id: ObjectID!, $input: UpdateBmpResultInput!) {
  updateBmpResult(id: $id, input: $input) {
    ... on UpdateBmpResultSuccessfulResponse {
      result {
        ...BmpAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${BmpAssessmentResultFragmentDoc}`;
export type UpdatePerformanceBmpResultsMutationFn = Apollo.MutationFunction<UpdatePerformanceBmpResultsMutation, UpdatePerformanceBmpResultsMutationVariables>;

/**
 * __useUpdatePerformanceBmpResultsMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceBmpResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceBmpResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceBmpResultsMutation, { data, loading, error }] = useUpdatePerformanceBmpResultsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerformanceBmpResultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceBmpResultsMutation, UpdatePerformanceBmpResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceBmpResultsMutation, UpdatePerformanceBmpResultsMutationVariables>(UpdatePerformanceBmpResultsDocument, options);
      }
export type UpdatePerformanceBmpResultsMutationHookResult = ReturnType<typeof useUpdatePerformanceBmpResultsMutation>;
export type UpdatePerformanceBmpResultsMutationResult = Apollo.MutationResult<UpdatePerformanceBmpResultsMutation>;
export type UpdatePerformanceBmpResultsMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceBmpResultsMutation, UpdatePerformanceBmpResultsMutationVariables>;